import { useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";

import ProgressBar from "./ProgressBar";
import CylinderSelection from "./stage/CylinderSelection";
import JobCardStage from "./stage/JobCardStage";
import { stepConfigs } from "../../config/jobCardStepConfig";
import { setJobCardData } from "../../../../redux/jobCardDataSlice";

const JobCardForm = ({ cylinderSetup, factorySetup }) => {
  const [currentStep, setCurrentStep] = useState(null);
  const jobCardData = useSelector((state) => state.jobCard.data);
  const dispatch = useDispatch();

  const completedSteps = useMemo(() => {
    return (
      jobCardData?.stageUpdates
        ?.filter((stage) => stage.status)
        .map((stage) => stage.stageId) || []
    );
  }, [jobCardData]);

  // Handle Next Button
  const nextStep = () => {
    setCurrentStep((prev) => prev + 1);
  };

  // Handle Previous Button

  const prevStep = () => {
    if (currentStep === 1) {
      setCurrentStep(null);
      dispatch(setJobCardData({})); // reset
      return;
    }
    setCurrentStep((prev) => prev - 1);
  };

  const setupMap = factorySetup.reduce((acc, item) => {
    acc[item.id] = item;
    return acc;
  }, {});

  return (
    <>
      {/* PROGRESS BAR HEADER */}
      {currentStep !== null && (
        <ProgressBar
          currentStep={currentStep}
          completedSteps={completedSteps}
          setCurrentStep={setCurrentStep}
        />
      )}
      {/* Cylinder selection to start the job card */}
      {currentStep === null && (
        <CylinderSelection
          cylinderSetup={cylinderSetup}
          setCurrentStep={setCurrentStep}
        />
      )}
      {/* 1 - 8 Stages */}
      {currentStep >= 1 && currentStep <= 8 && (
        <JobCardStage
          setupData={setupMap[currentStep]}
          currentStep={currentStep}
          stepConfig={stepConfigs[currentStep]}
        />
      )}
      {/* PREVIOUS - NEXT BUTTON */}
      <div className="next-btn-wrap gap-2">
        {currentStep !== null && (
          <button className="next-prev-button" onClick={prevStep}>
            Prev
          </button>
        )}
        {currentStep !== null && currentStep !== 8 && (
          <button className="next-prev-button" onClick={nextStep}>
            Next
          </button>
        )}
      </div>
    </>
  );
};
export default JobCardForm;
